import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("ll_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

let refreshPromise = null;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error?.config;
    const status = error?.response?.status;
    const url = original?.url || "";
    const isAuthCall = url.includes("/auth/login") || url.includes("/auth/logout") || url.includes("/auth/refresh");

    if (status !== 401 || !original || original._llRetried || isAuthCall) {
      return Promise.reject(error);
    }

    original._llRetried = true;
    try {
      if (!refreshPromise) {
        refreshPromise = api.post("/auth/refresh")
          .then(({ data }) => {
            if (data?.token) localStorage.setItem("ll_token", data.token);
            return data?.token;
          })
          .finally(() => { refreshPromise = null; });
      }
      const token = await refreshPromise;
      if (token) original.headers.Authorization = `Bearer ${token}`;
      return api(original);
    } catch (refreshError) {
      localStorage.removeItem("ll_token");
      return Promise.reject(refreshError);
    }
  }
);

export default api;

export const euro = (n) =>
  `€ ${Number(n || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const fmtDate = (iso) => {
  if (!iso) return "—";
  const [y, m, d] = iso.split("-");
  return `${d}/${m}/${y}`;
};

export const STATUSES = {
  prenotato: { label: "Prenotato", cls: "bg-sky-100 text-sky-700 border-sky-200" },
  confermato: { label: "Confermato", cls: "bg-blue-100 text-blue-700 border-blue-200" },
  arrivato: { label: "Arrivato", cls: "bg-amber-100 text-amber-700 border-amber-200" },
  in_trattamento: { label: "In trattamento", cls: "bg-violet-100 text-violet-700 border-violet-200" },
  completato: { label: "Completato", cls: "bg-emerald-100 text-emerald-700 border-emerald-200" },
  annullato: { label: "Annullato", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  non_presentato: { label: "Non presentato", cls: "bg-red-100 text-red-700 border-red-200" },
};

export const PAY_STATUS = {
  da_pagare: { label: "Da pagare", cls: "bg-red-50 text-red-600 border-red-200" },
  parziale: { label: "Parziale", cls: "bg-amber-50 text-amber-600 border-amber-200" },
  pagato: { label: "Pagato", cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
};

export const notifyChange = () => window.dispatchEvent(new CustomEvent("ll:data-changed"));

export const apiError = (e, fallback = "Si è verificato un errore") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return fallback;
};

// Verifica permesso effettivo dell'utente (override utente o preset ruolo)
export const can = (user, section, action = "view") => {
  const p = user?.effective_permissions?.[section];
  if (!p) return false;
  return p.includes(action) || p.includes("admin");
};
